import React from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { SingleInputField } from "../../../components";
import { loginData } from "../../../assets/lib/login";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#fff",
    color: "#000",
    padding: "20px",
    fontFamily: "Montserrat",
  },
  box: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    boxShadow: "0 0 15px rgba(0,0,0,0.05)",
    width: "100%",
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontFamily: "Montserrat",
  },
  title: { fontSize: "24px", fontWeight: "bold", textAlign: "center", marginBottom: "5px" },
  subtitle: { fontSize: "16px", textAlign: "center", color: "#555" },
  inputContainer: { display: "flex", flexDirection: "column", gap: "10px" },
  errorText: { color: "red", fontSize: "14px", marginBottom: "5px" },
  link: { color: "#007BFF", cursor: "pointer", textDecoration: "underline" },
  actions: { display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" },
});

const Layout = (props) => {
  const {
    loginState,
    errorFields,
    getLoginInput,
    handleLogin,
    loginFailedText,
    submitLoading,
    email,
    setEmail,
    emailOtp,
    setEmailOtp,
    emailVerified,
    generatedEmailOtp,
    handleSendEmailOtp,
    verifyEmailOtp,
    invalidCompanyEmail,
    campusDisabled,
    emailInvalidOtp,
    currentUserDoc,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      {submitLoading && <CircularLoader isPoistionAbsolute zIndex={3} />}

      <div className={classes.box}>
        <h1 className={classes.title}>Welcome to Alpaago</h1>
        <p className={classes.subtitle}>Login to continue</p>

        <div className={classes.inputContainer}>
          {/* Phone + Alpin */}
          <SingleInputField
            content={loginData.phoneNumber}
            value={loginState.phoneNumber}
            getInputData={getLoginInput}
            errorFields={errorFields}
          />
          <SingleInputField
            content={loginData.alpin}
            value={loginState.alpin}
            getInputData={getLoginInput}
            errorFields={errorFields}
          />

          {loginFailedText && <p className={classes.errorText}>{loginFailedText}</p>}

          {/* ---------- Email Verification (if user exists but no email) ---------- */}
          {currentUserDoc && !currentUserDoc.email && !emailVerified && (
            <>
              <SingleInputField
                content={{ label: "Professional Email", name: "email" }}
                value={email}
                getInputData={(e) => setEmail(e.target.value)}
                errorFields={errorFields}
              />

              {invalidCompanyEmail && (
                <p className={classes.errorText}>❌ Company email not found</p>
              )}
              {campusDisabled && (
                <p className={classes.errorText}>
                  🚫 Your organization access is disabled. Please contact your administrator.
                </p>
              )}

              {!generatedEmailOtp && (
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#000", color: "#fff" }}
                  onClick={handleSendEmailOtp}
                >
                  Send Email OTP
                </Button>
              )}

              {generatedEmailOtp && !emailVerified && (
                <>
                  <SingleInputField
                    content={{ label: "Email OTP", name: "emailOtp" }}
                    value={emailOtp}
                    getInputData={(e) => setEmailOtp(e.target.value)}
                  />
                  {emailInvalidOtp && (
                    <p className={classes.errorText}>❌ Invalid Email OTP</p>
                  )}
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#000", color: "#fff" }}
                    onClick={verifyEmailOtp}
                  >
                    Verify  OTP And Login
                  </Button>
                </>
              )}
            </>
          )}
        </div>

        <div className={classes.actions}>
          {/* Show Login button only if email verification is not needed */}
          {(!currentUserDoc || currentUserDoc.email || emailVerified) && (
            <Button
              variant="contained"
              sx={{ bgcolor: "#000", color: "#fff", fontWeight: "bold", width: { xs: "100px", sm: "200px" } }}
              onClick={handleLogin}
            >
              Login
            </Button>
          )}

          <p>
            Don’t have an account?{" "}
            <span className={classes.link} onClick={() => navigate(routes.SIGN_UP)}>
              Sign up 
            </span>
          </p>

          <p>
            Forgot your Alpin?{" "}
            <span className={classes.link} onClick={() => navigate(routes.FORGOT_ALPIN)}>
              Reset
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Layout;
